/* user/reducer */
import { createReducer } from "typesafe-actions";
import { ResetMfaActionTypes, ResetMfaState } from "./types";
import {
  saveRequest,
  saveSuccess,
  saveError,
} from "./actions";

export const initialState: ResetMfaState = {
  data: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
| ReturnType<typeof saveRequest>
| ReturnType<typeof saveSuccess>
| ReturnType<typeof saveError>

export default createReducer<ResetMfaState, ActionType>(initialState)
.handleType(ResetMfaActionTypes.SAVE_REQUEST, (state) => {
  return { ...state, loading: true, data: undefined, errors: undefined };
})
.handleType(ResetMfaActionTypes.SAVE_SUCCESS, (state, action) => {
  return {
    ...state,
    loading: false,
    data: action.payload,
    errors: undefined,
  };
})
.handleType(ResetMfaActionTypes.SAVE_ERROR, (state, action) => {
  return {
    ...state,
    loading: false,
    errors: action.payload,
    data: undefined,
  };
})
